const rawBaseUrl = process.env.VUE_APP_JAMENDO_BASE_URL || 'https://api.jamendo.com/v3.0'

export const clientId = process.env.VUE_APP_JAMENDO_CLIENT_ID || ''

export const base = `${rawBaseUrl.replace(/\/+$/, '')}/`
